import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';
import { Component, Input, Inject } from '@angular/core';


@Component({
    selector: 'deploymentConfirmAlert',
    styleUrls: ['./deployment-confirm.component.scss'],
    templateUrl: './deployment-confirm.component.html'
})
export class DeploymentConfirmAlertComponent {
    constructor(public modalComponentRef: BzgModalRef, @Inject(BZG_MODAL_DATA) public data: any) { }

    close() {
        this.modalComponentRef.close();
    }

    confirm() {
        this.modalComponentRef.close('confirm');
    }
}
